<template>
  <div>
    <h2>WANT TO SHOP THE SALE FIRST?</h2>

    <p>
      Create a Members Only account now and enjoy early sale access, exclusive
      benefits, and much more.
    </p>

    <Countdown :end="endDate" class="countdown" />

    <div class="button-group">
      <Button theme="primary-light" width="full" @click="$emit('login')">
        Log in
      </Button>
      <Button theme="outline" width="full" @click="$emit('register')">
        Sign Up Now
      </Button>
    </div>
  </div>
</template>

<script>
import Button from "@/components/ButtonV3.vue";
import Countdown from "@/components/landing/Countdown.vue";

export default {
  name: "HoldingOpening",
  components: {
    Countdown,
    Button,
  },
  props: {
    endDate: {
      type: String,
      required: true,
    },
  },
  emits: ["login", "register"],
};
</script>

<style lang="scss" scoped>
h2 {
  @include editorial-headline(24px);
  text-transform: uppercase;
  margin-bottom: 16px;
  text-wrap: balance;
}

p {
  @include editorial-body(14px);
  margin-bottom: 28px;
}

.countdown {
  margin-bottom: 28px;
}

.wishlist-button {
  display: inline-block;
}

:deep(.button--outline) {
  border-color: $color-white;
  color: $color-white;
}

.button-group {
  display: flex;
  gap: 20px;
  flex-direction: column;
}
</style>
